import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/document.svg'
import _imports_1 from '@/assets/logos/Sync_app.png'


const _withScopeId = n => (_pushScopeId("data-v-324536fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "How do you want to upload your tree?", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "method-title" }, "Upload a file", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "method-subtitle" }, null, -1))
const _hoisted_4 = { class: "method-icon" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = { class: "method-features features-file list-unstyled" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "FREE", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nothing to install", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No export to GEDCOM", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Upload your genealogy database directly", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "note" }, "Try the Sync app later")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "method-title" }, "Use the Sync app", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "method-subtitle" }, "(recommended)", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "method-icon"
}, null, -1))
const _hoisted_15 = { class: "method-features features-syncapp list-unstyled" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "FREE", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Easy to install", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No export to GEDCOM", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Upload your genealogy database directly", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "better" }, "Uploads your photos and documents too", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "better" }, "Easy to update your online tree over time", -1))

import { ref } from 'vue'
import { usePageTitle } from '@webapp/util/AppUtil'
import TaskPage from '@webapp/util/TaskPage.vue'
import { ArrowUpIcon, CheckIcon, StarIcon, UploadIcon } from '@zhuowenli/vue-feather-icons'


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncMethodPage',
  emits: ['choose-file'],
  setup(__props, { emit }) {



const showFeaturesRef = ref(false)

usePageTitle('Upload my tree')

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(TaskPage, {
    "no-brand": "",
    "no-back": "",
    "no-action": ""
  }, {
    title: _withCtx(() => [
      _createTextVNode("Upload my tree")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", {
        class: _normalizeClass(["method-grid", { 'show-features': showFeaturesRef.value }])
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-choice card-file",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('choose-file')))
        }, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_unref(ArrowUpIcon))
          ])
        ]),
        _withDirectives(_createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", null, [
            _createVNode(_unref(CheckIcon), { size: "20" }),
            _hoisted_7
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(CheckIcon), { size: "20" }),
            _hoisted_8
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(CheckIcon), { size: "20" }),
            _hoisted_9
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(CheckIcon), { size: "20" }),
            _hoisted_10
          ]),
          _hoisted_11
        ], 512), [
          [_vShow, showFeaturesRef.value]
        ]),
        _createVNode(_component_router_link, {
          to: "/sync/new/syncapp",
          class: "btn btn-choice card-syncapp"
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _hoisted_13,
            _hoisted_14
          ]),
          _: 1
        }),
        _withDirectives(_createElementVNode("ul", _hoisted_15, [
          _createElementVNode("li", null, [
            _createVNode(_unref(CheckIcon), { size: "20" }),
            _hoisted_16
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(CheckIcon), { size: "20" }),
            _hoisted_17
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(CheckIcon), { size: "20" }),
            _hoisted_18
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(CheckIcon), { size: "20" }),
            _hoisted_19
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(StarIcon), { size: "30" }),
            _hoisted_20
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(StarIcon), { size: "30" }),
            _hoisted_21
          ])
        ], 512), [
          [_vShow, showFeaturesRef.value]
        ])
      ], 2),
      _withDirectives(_createElementVNode("button", {
        type: "button",
        class: "btn btn-link choose-help",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showFeaturesRef.value = true))
      }, " Which one should I choose? ", 512), [
        [_vShow, !showFeaturesRef.value]
      ])
    ]),
    _: 1
  }))
}
}

})